<template>
    <el-select
        v-model="model_value"
        :placeholder="model_name"
        clearable
        filterable
        remote
        reserve-keyword
        :remote-method="remoteMethod"
        :loading="loading"
        :extend="extend"
        value-key="rid"
        :disabled="is_disabled"
        @change="onChange"
        ref="commonSearch"
    >
        <el-option v-for="item in options" :key="item.rid" :label="item.name" :value="item"> </el-option>
    </el-select>
</template>

<script>
export default {
    name: 'commonSearchSelect',
    props: {
        model_key: {
            // 请求后台的参数key（整体数据搜索）
            type: String
        },
        model_name: {
            // 下拉搜索框预显示名称
            type: String
        },
        search_key: {
            // 请求后台的参数key（请求搜索下拉接口）
            type: String,
            default: 'name'
        },
        request_uri: {
            // 下拉搜索框请求后台的地址映射
            type: String
        },
        is_disabled: {
            // 是否禁用
            type: Boolean,
            default: false
        },
        search_value_validate: {
            // 是否验证搜索值
            type: String,
            default: ''
        },
        default_option_key: {
            // 默认值选项保存在父组件的key
            type: String
        },
        default_option: {
            // 默认值选项
        },
        extend: {
            // 扩展参数
        }
    },
    data() {
        return {
            model_value: {},
            options: [],
            loading: false,
            extend_plus: null
        };
    },
    watch: {
        // 列表上使用该组件，请遵循动态key+formData来实现数据映射
        model_key() {
            this.init();
        },
        default_option() {
            this.init();
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            if (!this.default_option || !this.default_option.hasOwnProperty('rid') || this.default_option.rid == '') {
                this.options = [];
                this.model_value = {};
                return true;
            }
            this.options = [this.default_option];
            this.model_value = this.default_option;
        },
        remoteMethod(search_value) {
            // 特殊场景不多，先直接在这里写一下
            if (this.search_value_validate == 'flow_validate') {
                let returnFlase = true;

                // 通配，近期500条符合条件的
                if (search_value == '*') {
                    returnFlase = false;
                }

                if (returnFlase) {
                    // RID验证
                    let re = /^CMFL\d{10}$/i;
                    if (re.test(search_value)) {
                        returnFlase = false;
                    }
                }

                if (returnFlase) {
                    // 日期验证，不严格验证
                    let re = /^\d{4}-\d{2}-\d{2}$/;
                    if (re.test(search_value)) {
                        returnFlase = false;
                    }
                }

                if (returnFlase) {
                    this.options = [];
                    return false;
                }
            }

            if (search_value != '') {
                this.loading = true;
                let params = {};
                params[this.search_key] = search_value;
                if (this.extend) {
                    params['extend'] = this.extend;
                }
                if (this.extend_plus) {
                    params['extend'] = this.extend_plus;
                }
                this.$api[this.request_uri](params)
                    .then((res) => {
                        this.loading = false;
                        this.options = res.data;
                        if (this.options.length == 1) {
                            this.$refs.commonSearch.blur();
                            this.model_value = res.data[0];
                            this.onChange(res.data[0]);
                        }
                    })
                    .catch((error) => {
                        this.loading = false;
                        this.options = [];
                    });
            } else {
                this.loading = false;
                this.options = [];
            }
        },
        reset() {
            this.model_value = {};
            this.options = [];
            this.loading = false;
        },
        onChange(value) {
            // 和下拉框公用一个方法
            this.$emit('onDropChange', this.model_key, value.rid || '', 'value');
            this.$emit('onDropChange', this.default_option_key, value, 'option');
        },
        selectFirstOption() {
            // 获取 el-select 组件
            const selectComponent = this.$refs.commonSearch;
            if (selectComponent) {
                // 获取 el-option 的第一个值
                const firstOption = selectComponent.options[0];
                if (firstOption) {
                    // 选中第一个 option
                    selectComponent.setValue(firstOption);
                }
            }
        }
    }
};
</script>

<style>
</style>